import "./About.css"
export default function About(){
    return(<div className="about" id="about">
        <div className="right">
               <div className="Headt">     
                       <h1>عن الدكتور مصطفى الخشت</h1>
                </div>
            <div className="ab">
            الدكتور متخصص في مجال الحقن المجهري وأطفال الأنابيب، وبيتمتع بخبرة طويلة في علاج العقم وتأخر الإنجاب. على مدار السنوات، قدر يساعد مئات الأزواج على تحقيق حلمهم بالأمومة والابوة، بفضل التزامه بأحدث الأساليب الطبية والتقنيات المتطورة. الدكتور بيهتم جدًا بتقديم رعاية شخصية لكلمريض، مع متابعة دقيقة لكل مرحلة من مراحل العلاج لضمان أفضل النتائج. رؤيته دايمًا إن كل حالة تستحق العناية والدعم لتحقيق أفضل فرص النجاح في الإنجاب

            </div>
            <ul>
                <li > <span><img src="/assets/tick-icon-sign-symbol-design-free-png 1.png"/></span>   رعاية طبية فائقة بأحدث الأساليب العلمية     </li>
                <li><span><img src="/assets/tick-icon-sign-symbol-design-free-png 1.png"/></span>  تواصل فعال علي مدار 24 ساعة   </li>
                <li><span><img src="/assets/tick-icon-sign-symbol-design-free-png 1.png"/></span>  أعلي نسبة حمل في مجال الحقن المجهري   </li>
                <li><span><img src="/assets/tick-icon-sign-symbol-design-free-png 1.png"/></span>        إستخدام أحدث الاساليب العلمية والعلاجية    </li>



            </ul>
        </div>
        <div className="left">
            
        </div>

    </div>)
}